export default __webpack_public_path__ + "static/JakubDąbroś-75d0f352a14d9ef72a159506f472b998.png";